/* Sale Items section — client-side product scan.
   Runs against /products.json (paged, no cap) instead of Liquid's
   collections.all.products (hard-capped at 250 per render), so this keeps
   finding every on-sale product no matter how large the catalog grows. */
(function () {
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimalSep) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimalSep = typeof decimalSep === 'undefined' ? '.' : decimalSep;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimalSep + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : formatString + value;
  }

  function appendImageSize(src, width) {
    if (!src) return src;
    var queryIndex = src.indexOf('?');
    var base = queryIndex > -1 ? src.slice(0, queryIndex) : src;
    var query = queryIndex > -1 ? src.slice(queryIndex) : '';
    var extDot = base.lastIndexOf('.');
    if (extDot === -1) return src;
    return base.slice(0, extDot) + '_' + width + 'x' + base.slice(extDot) + query;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  async function fetchAllProducts() {
    var all = [];
    for (var page = 1; page <= 40; page++) {
      var res = await fetch('/products.json?limit=250&page=' + page);
      if (!res.ok) break;
      var data = await res.json();
      if (!data.products || data.products.length === 0) break;
      all = all.concat(data.products);
      if (data.products.length < 250) break;
    }
    return all;
  }

  function computeSaleItems(products) {
    var items = [];
    products.forEach(function (p) {
      var bestDiscount = 0;
      var bestVariant = null;
      var onSale = false;
      (p.variants || []).forEach(function (v) {
        var price = parseFloat(v.price);
        var compare = v.compare_at_price ? parseFloat(v.compare_at_price) : null;
        if (compare && compare > price) {
          onSale = true;
          var d = ((compare - price) / compare) * 100;
          if (d > bestDiscount || !bestVariant) {
            bestDiscount = d;
            bestVariant = v;
          }
        }
      });
      if (onSale && bestVariant) {
        items.push({
          title: p.title,
          vendor: p.vendor,
          handle: p.handle,
          url: '/products/' + p.handle,
          discount: bestDiscount,
          available: (p.variants || []).some(function (v) { return v.available; }),
          price: parseFloat(bestVariant.price),
          compareAtPrice: parseFloat(bestVariant.compare_at_price),
          image: p.images && p.images[0] ? p.images[0].src : null,
          hoverImage: p.images && p.images[1] ? p.images[1].src : null
        });
      }
    });
    return items;
  }

  function renderSection(root) {
    var sectionId = root.getAttribute('data-rls-section-id');
    var settingsEl = document.querySelector('[data-rls-settings="' + sectionId + '"]');
    var gridEl = document.querySelector('[data-rls-grid="' + sectionId + '"]');
    var emptyEl = document.querySelector('[data-rls-empty="' + sectionId + '"]');
    var countEl = document.querySelector('[data-rls-count="' + sectionId + '"]');
    if (!settingsEl || !gridEl) return;

    var settings;
    try {
      settings = JSON.parse(settingsEl.textContent);
    } catch (e) {
      return;
    }

    fetchAllProducts()
      .then(function (products) {
        var items = computeSaleItems(products).filter(function (item) {
          return settings.showSoldOut || item.available;
        });

        items.sort(function (a, b) {
          return settings.sortDirection === 'low_to_high'
            ? a.discount - b.discount
            : b.discount - a.discount;
        });

        var totalOnSale = items.length;
        var maxProducts = parseInt(settings.maxProducts, 10) || 0;
        var displayItems = maxProducts > 0 ? items.slice(0, maxProducts) : items;
        var roundTo = parseInt(settings.roundTo, 10) || 10;

        if (countEl) {
          countEl.textContent = totalOnSale + (totalOnSale === 1 ? ' item on sale' : ' items on sale');
        }

        if (displayItems.length === 0) {
          gridEl.style.display = 'none';
          gridEl.innerHTML = '';
          if (emptyEl) emptyEl.style.display = '';
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        gridEl.style.display = '';

        gridEl.innerHTML = displayItems
          .map(function (item) {
            var rounded = Math.round(item.discount / roundTo) * roundTo;
            var titleClass = 'rls-card__title' + (settings.uppercase ? ' rls-uppercase' : '');
            var img = item.image
              ? '<img class="rls-card__image" src="' +
                escapeHtml(appendImageSize(item.image, 800)) +
                '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="800" height="800">'
              : '';
            var hoverImg = item.hoverImage
              ? '<img class="rls-card__image rls-card__image--hover" src="' +
                escapeHtml(appendImageSize(item.hoverImage, 800)) +
                '" alt="" loading="lazy" width="800" height="800">'
              : '';
            var vendor = settings.showVendor
              ? '<p class="rls-card__vendor">' + escapeHtml(item.vendor) + '</p>'
              : '';
            var soldOut = settings.showSoldOut && !item.available
              ? '<span class="rls-soldout">' + escapeHtml(settings.soldOutLabel) + '</span>'
              : '';
            var priceCents = Math.round(item.price * 100);
            var compareCents = Math.round(item.compareAtPrice * 100);

            return (
              '<li class="rls-card">' +
                '<a href="' + escapeHtml(item.url) + '" class="rls-card__link">' +
                  '<div class="rls-card__image-wrap rls-ratio-' + escapeHtml(settings.ratio) + '">' +
                    img + hoverImg +
                    '<span class="rls-badge">' + rounded + escapeHtml(settings.badgeSuffix) + '</span>' +
                    soldOut +
                  '</div>' +
                  '<div class="rls-card__info">' +
                    vendor +
                    '<p class="' + titleClass + '">' + escapeHtml(item.title) + '</p>' +
                    '<p class="rls-card__price">' +
                      '<span class="rls-card__price--sale">' + formatMoney(priceCents, settings.moneyFormat) + '</span>' +
                      '<span class="rls-card__price--compare">' + formatMoney(compareCents, settings.moneyFormat) + '</span>' +
                    '</p>' +
                  '</div>' +
                '</a>' +
              '</li>'
            );
          })
          .join('');
      })
      .catch(function (err) {
        console.error('Sale Items section failed to load products:', err);
        if (countEl) countEl.textContent = '';
        gridEl.style.display = 'none';
        if (emptyEl) {
          emptyEl.style.display = '';
          var p = emptyEl.querySelector('p');
          if (p) p.textContent = 'Sale items are temporarily unavailable.';
        }
      });
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-rls-root]').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-run when the theme editor re-renders this section (live settings preview).
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-rls-root]');
    if (root) renderSection(root);
  });
})();
